import { ulid } from "ulid";
import { IGroup } from "../common/IGroup.intf";
import { IActionData, IActionJavaData, IActionShellData } from "./IAction.intf";
import { createMergeToDefaultData } from "../utils/mergeToDefaultData";
export const actionGroupType = 'actionGroup'
export interface IActionGroup extends IGroup<IActionData<IActionShellData, IActionJavaData>>{
    type:string
    id:string
}

function createDefultData():IActionGroup{
    return {
        type:actionGroupType,
        id:ulid(),
        list:[],
        checks:[],
        isSequential:true
    }
}

export interface IActionGroupUtils{
    type:string
    createDefultData:()=>IActionGroup
    mergeDataToDefultData:(data:Partial<IActionGroup>)=>IActionGroup
}

export const actionGroupUtils:IActionGroupUtils = {
    type:actionGroupType,
    createDefultData,
    mergeDataToDefultData:createMergeToDefaultData(createDefultData)
}
